<template>
    <section class="contact">
        <PageIntro title="Contato" :notbar="true"/>

        <div class="contact-text container">
            <h2 class="contact-text__title">Dúvidas, orçamentos ou sugestões</h2>
            <p class="contact-text__text">Fique a vontade para para falar diretamento com nossa equipe de atendimento. Ficaremos felizes em atender sua solitação ou fazer seu orçamento sem compromisso. </p>
        </div>
        <ContactForm/>
        <Local/>
    </section>
</template>

<script>
    import ContactForm from "../components/Contact/ContactForm/ContactForm";
    import PageIntro from "../components/Shared/PageIntro";
    import Local from "../components/Contact/Local/Local";

    export default {
        name: "Contact",
        components: {
            ContactForm,
            PageIntro,
            Local
        },
        mounted() {
            document.title = 'Fibrillare - Contato';
        }
    }
</script>

<style lang="scss" scoped>
    .contact-text {
        &__title, &__text {
            margin: 0 auto;
            text-align: center;
            color: #2b2b2b;
        }

        &__title {
            max-width: 970px;
            margin-bottom: 20px;
            font-family: 'Poppins', Arial, sans-serif;
            font-weight: 500;
            font-size: 2rem;
        }

        &__text {
            max-width: 770px;
            font-family: 'Open Sans';
            font-weight: 400;
            font-size: 1rem;
        }
    }

    @media only screen and (min-width: 1025px) and (max-width: 1440px) {
        .not-home-intro {
            margin-bottom: 60px;
            height: 40vh;
            background-size: cover;
        }

        .not-home-intro__text {
            padding-top: 80px;
            font-size: 2rem;
            font-weight: 400;
        }

        .contact-text__title {
            font-weight: 400;
        }
    }

    @media only screen and (max-width: 1024px) {
        .not-home-intro {
            margin-bottom: 60px;
            height: 400px;
            background-size: cover;
        }

        .not-home-intro__text {
            top: 50%;
        }
    }

    @media only screen and (max-width: 767px) {
        .contact-text__title {
            margin-bottom: 10px;
            font-weight: 500;
            font-size: 1.375rem;
        }

        .contact-text__text {
            font-size: 0.875rem;
        }
    }
</style>